module.exports = __webpack_public_path__ + "img/healthy_page04_img.12a04d6a.gif";